import apiClient from './apiClient';

const blogApi = {
  listPosts: (params?: { limit?: number; skip?: number }) =>
    apiClient.get('/blog', { params }).then((r) => r.data),

  getPost: (slug: string) =>
    apiClient.get(`/blog/${slug}`).then((r) => r.data),

  trackView: (slug: string) =>
    apiClient.post(`/blog/${slug}/view`).catch(() => {}),
};

export default blogApi;
